import axios from "axios";
import { useEffect, useState } from "react";
import { constants } from "../constants";

export const useCrossChainData = () => {
  const [CCTVL, setCCTVL] = useState<string | null>("0");

  const getData = () => {
    axios.get(constants.url.tvl).then((res: any) => {
      setCCTVL(parseFloat(res.data.totalUSD).toFixed());
    });
  };

  useEffect(() => {
    getData();
    const interval = setInterval(() => {
      getData();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  return { CCTVL };
};
